import {collection, getDocs, query, where} from "@firebase/firestore";
import {db} from "../config";

export const fetchUser = async(user: any)=> {
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs[0].data()
}
